export const SendEmailNodeIcon = () => {
  return (
    <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.6044 3.51562L11.5227 10.3293C10.6762 11.1444 9.32384 11.1444 8.47734 10.3293L1.39563 3.51562C0.972374 3.92319 0.714294 4.49796 0.714294 5.13544V14.8752C0.714294 16.1293 1.74661 17.143 3.01637 17.143H16.9837C18.2534 17.143 19.2857 16.1293 19.2857 14.8752V5.13544C19.2857 4.50841 19.0276 3.93364 18.6044 3.51562Z" fill="#139E60" />
      <path d="M11.5227 8.77211L17.5927 2.94078C17.3966 2.88853 17.2004 2.85718 16.994 2.85718H3.00603C2.79957 2.85718 2.59311 2.88853 2.40729 2.94078L8.47733 8.77211C9.32383 9.58724 10.6762 9.58724 11.5227 8.77211Z" fill="#139E60" />
    </svg>
  );
};
